import { render } from "./VUEAppContentSchedaUtente.vue?vue&type=template&id=96f47fe2"
import script from "./VUEAppContentSchedaUtente.vue?vue&type=script&lang=js"
export * from "./VUEAppContentSchedaUtente.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__